// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

import { Store } from "#/store";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class VideoModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  get videoUrl() {
    if (this.instance["videolink"]["type"] === "embed") {
      return this.instance["videolink"]["embedUrl"];
    } else if (this.instance["videolink"]["uploadUrl"].split("/").length > 5) {
      return this.instance["videolink"]["uploadUrl"];
    } else {
      return (
        Store.instance.page.page!.s3Url +
        this.instance["videolink"]["uploadUrl"]
      );
    }
  }

  get autoplay() {
    return this.instance["autoplay"];
  }

  get autoplayMuted() {
    return this.instance["autoplay_muted"];
  }

  get autoplayOnlyVisible() {
    return this.instance["autoplay_if_in_view"];
  }

  get controls() {
    return !this.instance["hidecontrol"];
  }

  get videoLoop() {
    return this.instance["video_loop"];
  }
}
